"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditPolicyLinesOfCoverageModal = void 0;
var noop_1 = __importDefault(require("lodash/noop"));
var react_1 = __importDefault(require("react"));
var update_policy_locs_1 = require("../../mutations/update-policy-locs");
var add_lines_of_coverage_modal_1 = require("../add-lines-of-coverage-modal");
function EditPolicyLinesOfCoverageModal(_a) {
    var _this = this;
    var _b;
    var isOpen = _a.isOpen, policy = _a.policy, _c = _a.onSubmitSuccess, onSubmitSuccess = _c === void 0 ? noop_1.default : _c, onToggle = _a.onToggle;
    var updateLocs = update_policy_locs_1.useUpdatePolicyLocs()[0];
    if (!isOpen) {
        return null;
    }
    return (react_1.default.createElement(add_lines_of_coverage_modal_1.AddLinesOfCoverageModal, { onSubmit: function (locs) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, updateLocs({
                            params: {
                                policyUuid: (_a = policy.uuid) !== null && _a !== void 0 ? _a : '',
                            },
                            body: {
                                linesOfCoverage: locs.map(function (loc) {
                                    var _a;
                                    return ({
                                        uuid: loc.uuid,
                                        data: {},
                                        type: loc.type,
                                        version: loc.version,
                                        displayName: (_a = loc.displayName) !== null && _a !== void 0 ? _a : undefined,
                                    });
                                }),
                            },
                        })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }); }, title: "Manage lines of coverage", options: {
            filterByProgram: (_b = policy.definition) === null || _b === void 0 ? void 0 : _b.program,
        }, renderSubmitButtonLabel: function (locs) { return 'Update lines of coverage'; }, onSubmitSuccess: onSubmitSuccess, onClose: onToggle, initialLineOfCoverageTypeDetails: policy.linesOfCoverage.map(function (loc) { return ({
            type: loc.type,
            version: loc.version,
            displayName: loc.displayName,
            uuid: loc.uuid,
        }); }) }));
}
exports.EditPolicyLinesOfCoverageModal = EditPolicyLinesOfCoverageModal;
